import { render, staticRenderFns } from "./registrations.vue?vue&type=template&id=47781ee5&"
import script from "./registrations.vue?vue&type=script&lang=js&"
export * from "./registrations.vue?vue&type=script&lang=js&"
import style0 from "./registrations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports